<div *ngIf="userKalakarData && userKalakarData.length > 0" class="bg-[#FFFDF8] px-2.5 py-4 space-y-1.5 md:space-y-3.5">
    <div class="flex items-center justify-start gap-4">
      <div>
        <img class="size-24" [src]="userKalakarData[0].documents?.[0]?.doc_user_img || 'assets/images/default-user.png'" alt="employee">
      </div>
      <div>
        <p class="text-[#444] text-xs sm:text-sm lg:text-base font-normal capitalize">{{userKalakarData[0].name}} {{userKalakarData[0].user_last_name}}</p>
        <p class="text-[#444] text-xs sm:text-sm lg:text-base font-medium capitalize">{{userKalakarData[0].user_supplier_type}}</p>
      </div>

    </div>
    <div class="flex items-center justify-start text-444 text-xs sm:text-sm gap-x-2">
        <p class="w-[100px] capitalize">Kalakaar ID</p>
        <p>:</p>
        <p>{{userKalakarData[0].id}}</p>
    </div>
    <div class="flex items-center justify-start text-444 text-xs sm:text-sm gap-x-2">
        <p class="w-[100px] capitalize">Contact No.</p>
        <p>:</p>
        <p>{{userKalakarData[0].mobilenumber}}</p>
    </div>
    <div class="flex items-center justify-start text-444 text-xs sm:text-sm gap-x-2">
        <p class="w-[100px] capitalize">Email ID</p>
        <p>:</p>
        <p>{{userKalakarData[0].email}}</p>
    </div>
    <div class="flex items-center justify-start text-444 text-xs sm:text-sm gap-x-2">
        <p class="w-[100px] capitalize">City</p>
        <p>:</p>
        <p>{{userKalakarData[0].city_id}}</p>
    </div>
    <div class="flex items-center justify-start text-444 text-xs sm:text-sm gap-x-2">
        <p class="w-[100px] capitalize">Birth Date</p>
        <p>:</p>
        <p>{{userKalakarData[0].user_dob}}</p>
    </div>
    <div class="flex items-center justify-start text-444 text-xs sm:text-sm gap-x-2">
        <p class="w-[100px] capitalize">Blood Group</p>
        <p>:</p>
        <p>O +ve</p>
    </div>
</div>
